<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
		<HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <router-view />
    <!--创建彈框--->
    <DtartedDialog v-if="$store.getters.startedDialogVisible" @success="()=>{successType = 1}" />
    <!--创建成功弹框-->
    <CreatSuccessDialog v-if="$store.getters.createSuccessVisible">
      <template v-if="successType == 1" v-slot:successCreate>
        <img src="@/assets/img/client/login/pic_email.png" width="300px" height="200px">
        <p class="boldFont">欢迎</p>
        <div class="grayFont">您距离无缝运费比较仅一步之遥</div>
        <div class="grayFont margin8">请检查kehu@email.com以验证您的帐户。</div>
        <div class="blueFont" style="cursor: pointer;" @click="send">重发电子邮件</div>
      </template>
      <template v-if="successType == 2" v-slot:successLogin>
        <img src="@/assets/img/client/login/pic_email_2.png" width="300px" height="200px">
        <div class="boldFont margin8">请查看您的邮件</div>
        <div class="grayFont">邮件已发送至 {{ resetEmail }}</div>
        <div class="grayFont margin8">请点击重置链接重置密码.</div>
      </template>
    </CreatSuccessDialog>
    <!--登录弹框-->
    <LoginDialog v-if="$store.getters.loginDialogVisible" @success="()=>{successType = 2}" />
    <!--聊天框-->
    <!-- <ChatDialog v-if="$store.getters.chatDialogVisible"></ChatDialog> -->
  </div>
</template>

<script>
import {
  SendActivateEmail,
  GetCurrCustomer
} from 'api/user.js'
import DtartedDialog from './client/login/startedDialog.vue'
import CreatSuccessDialog from './client/login/CreatSuccessDialog.vue'
import LoginDialog from './client/login/LoginDialog.vue'
import ChatDialog from './client/home/chatBox/index.vue'
export default {
  name: 'App',
  components: {
    DtartedDialog,
    CreatSuccessDialog,
    LoginDialog,
    ChatDialog
  },
  data() {
    return {
      successType: 1,
      resetEmail: ''
    }
  },
  created() {

  },
  mounted() {
    this.resetEmail = localStorage.getItem('resetEmail')
  },
  methods: {
    send() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          SendActivateEmail(res.data.id)
        }
      })
    }
  }
}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
</style>
